import { createApp } from 'vue';

import pageLoaded from 'JIX/utils/pageLoaded.js';

import CompanyProfileApp from 'JIX/components/companyprofile/CompanyProfileApp.vue';
import createStore from 'JIX/store/companyprofile.js';
import HighchartsVue from 'highcharts-vue';

import Highcharts from 'highcharts';
import { getGlobalChartOptions } from 'JIX/highcharts/configs/generic_chart.js';

const stash = window.Stash['companyprofile'];

Highcharts.setOptions(getGlobalChartOptions());

const store = createStore({ ...stash });

const app = createApp(CompanyProfileApp);
app.use(HighchartsVue, { tagName: 'Highcharts' });
app.use(store);

pageLoaded().then(() => {
    app.mount('#company-profile');
});
